import {StyleSheet} from 'react-native';
import Typography from '../../../../shared/constants/Typography';

/**
 * @param isNarrow web viewport < 600 px (e.g. 320 px = 1280 px at 400% zoom,
 *   WCAG 1.4.10 Reflow): the header grows taller and its sections wrap instead
 *   of overflowing. Never true on native or at normal desktop widths.
 */
export const createHeaderStyles = (theme: any, isNarrow: boolean = false) =>
  StyleSheet.create({
    headerContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%', // ensures full width
      maxWidth: '100%',
      paddingHorizontal: Typography.padding.padding32,
      paddingVertical: Typography.padding.padding18,
      paddingLeft: Typography.padding.padding10,
      backgroundColor: theme.backgroundColor,
      shadowOffset: {width: 0, height: Typography.height.height4},
      shadowOpacity: 0.06,
      shadowColor: theme.shadowColor,
      shadowRadius: Typography.radius.radius8,
      elevation: 8,
      height: Typography.height.height80,
      borderBottomColor: theme.border,
      borderBottomWidth: Typography.borderWidth.borderWidth1,
      ...(isNarrow && {
        flexWrap: 'wrap',
        height: 'auto',
        minHeight: Typography.height.height80,
        paddingHorizontal: Typography.padding.padding12,
        paddingLeft: Typography.padding.padding12,
        paddingVertical: Typography.padding.padding12,
        rowGap: Typography.gap.gap12,
      }),
    },
    headerLeft: {
      flexDirection: 'row',
      alignItems: Typography.textAlign.centerAlign,
      flex: 1, // allows left section to take available space
      gap: Typography.gap.gap12,
      ...(isNarrow && {flexWrap: 'wrap', flexBasis: '100%', minWidth: 0}),
    },
    headerRight: {
      flexDirection: 'row',
      alignItems: Typography.textAlign.centerAlign,
      gap: Typography.gap.gap22,
      ...(isNarrow && {
        flexWrap: 'wrap',
        flexBasis: '100%',
        minWidth: 0,
        gap: Typography.gap.gap12,
      }),
    },
    buttonsContainer: {
      flexDirection: 'row',
      alignItems: Typography.textAlign.centerAlign,
      gap: Typography.gap.gap24,
      ...(isNarrow && {flexWrap: 'wrap', gap: Typography.gap.gap12}),
    },
    logo: {
      // width: Typography.width.width30,
      // height: Typography.height.height30,
      flexDirection: 'row',
      justifyContent: Typography.textAlign.centerAlign,
      alignItems: Typography.textAlign.centerAlign,
      backgroundColor: theme.backgroundColor,
      // borderWidth: Typography.borderWidth.borderWidth1,
      // borderColor: theme.logoBorder,
    },
    logoText: {
      color: theme.logoText,
      fontSize: Typography.fontSize.fontSize26,
      textAlign: Typography.textAlign.centerAlign,
      fontWeight: Typography.fontWeight.fullBold,
      fontFamily: Typography.fontFamily.rethinkSans,
    },
    logoSubText: {
      color: theme.logoText,
      fontSize: Typography.fontSize.fontSize26,
      textAlign: Typography.textAlign.centerAlign,
      fontWeight: Typography.fontWeight.regular,
      fontFamily: Typography.fontFamily.rethinkSans,
    },
    logoImage: {
      width: Typography.width.width140,
      height: Typography.height.height35,
    },
    selectedShopText: {
      color: theme.logoText,
      fontSize: Typography.fontSize.fontSize12,
      fontWeight: Typography.fontWeight.medium,
      fontFamily: Typography.fontFamily.inter,
      textAlign: Typography.textAlign.centerAlign,
    },
    selectedShop: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: Typography.gap.gap6,
      backgroundColor: theme.selectedShopBGColor,
      borderRadius: Typography.radius.radius8,
      paddingVertical: Typography.padding.padding6,
      paddingHorizontal: Typography.padding.padding12,
      marginLeft: Typography.margin.margin12,
      height: Typography.height.height36,
      ...(isNarrow && {marginLeft: 0, maxWidth: '100%'}),
    },
    searchInputContainer: {
      flex: 1, // stretch to fill left space
      marginLeft: Typography.margin.margin45,
      height: Typography.height.dropDownheight,
      maxHeight: Typography.height.dropDownheight,
    },
    containerStyle: {
      maxWidth: Typography.width.width319,
      maxHeight: Typography.height.dropDownheight,
    },
    helperIcon: {
      flexDirection: 'row',
      alignItems: Typography.textAlign.centerAlign,
      gap: Typography.gap.gap8,
    },
    helpText: {
      color: theme.helpText,
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.medium,
    },
    disabledView: {
      opacity: 0.5,
      pointerEvents: 'none',
    },
    logoutButtonContainer: {
      //borderColor: theme.shopHomeLogoutCTABorder,
      //borderRadius: Typography.radius.radius4,
      borderWidth: Typography.borderWidth.borderWidth1,
      alignItems: Typography.textAlign.centerAlign,
      justifyContent: Typography.textAlign.centerAlign,
      flexDirection: 'row',
      gap: Typography.gap.gap8,
      paddingHorizontal: Typography.padding.padding16,
      paddingVertical: Typography.padding.padding7,
      backgroundColor: 'transparent',
    },
    logoutText: {
      //color: theme.shopHomeLogoutCTAText,
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.medium,
    },
    languageContainer: {
      flexDirection: 'row',
      gap: Typography.gap.gap8,
    },
    languageDropdown: {
      color: theme.languageSelectedText,
      textTransform: 'uppercase',
    },
    languageMainDropdown: {
      borderColor: 'transparent',
      paddingHorizontal: Typography.padding.padding10,
      paddingVertical: Typography.padding.padding20,
      height: Typography.height.height20,
    },
    shiftStatusIndicator: {
      backgroundColor: theme.shiftStatus,
      borderRadius: Typography.radius.radius8,
      paddingHorizontal: Typography.padding.padding26,
      paddingVertical: Typography.padding.padding9
    },
    subTitle: {
      fontSize: Typography.fontSize.fontSize12,
      color: theme.statusText,
      fontWeight: Typography.fontWeight.medium,
      fontFamily: Typography.fontFamily.inter,
      lineHeight: Typography.lineHeight.lineHeight20,
    },
    indirectDisabledText: {
      //color: theme.CTADisabledText,
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.medium,
    },
    indirectEnabledText: {
      //color: theme.IndirectActivityCTAText,
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.medium,
    },
    indirectActivityDisabledContainer: {
      //borderColor: theme.CTADisabledBG,
      borderRadius: Typography.radius.radius8,
      borderWidth: Typography.borderWidth.borderWidth1,
      alignItems: Typography.textAlign.centerAlign,
      justifyContent: Typography.textAlign.centerAlign,
      flexDirection: 'row',
      gap: Typography.gap.gap8,
      paddingHorizontal: Typography.padding.padding16,
      paddingVertical: Typography.padding.padding7,
      //backgroundColor: theme.saveNoteCTADisabledBG,
      //backgroundColor: 'transparent',
    },
    indirectActivityEnabledContainer: {
      borderColor: theme.IndirectActivityCTABorder,
      borderRadius: Typography.radius.radius8,
      borderWidth: Typography.borderWidth.borderWidth1,
      alignItems: Typography.textAlign.centerAlign,
      justifyContent: Typography.textAlign.centerAlign,
      flexDirection: 'row',
      gap: Typography.gap.gap8,
      paddingHorizontal: Typography.padding.padding16,
      paddingVertical: Typography.padding.padding7,
      backgroundColor: 'transparent',
      //backgroundColor: 'transparent',
    },
    quickAssistText: {
      color: theme.quickAssitCTAText,
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.medium,
    },
    quickAssistContainer: {
      borderColor: theme.quickAssitCTABorder,
      borderRadius: Typography.radius.radius8,
      borderWidth: Typography.borderWidth.borderWidth1,
      alignItems: Typography.textAlign.centerAlign,
      justifyContent: Typography.textAlign.centerAlign,
      flexDirection: 'row',
      gap: Typography.gap.gap8,
      paddingHorizontal: Typography.padding.padding16,
      paddingVertical: Typography.padding.padding7,
      backgroundColor: 'transparent',
    },
    buttonContainerTextStyles: {
      gap: Typography.gap.gap8,
      alignItems: Typography.textAlign.centerAlign,
    },
    blockContainer: {
      flexDirection: 'row',
      gap: Typography.gap.gap20,
      alignItems: Typography.textAlign.centerAlign,
      ...(isNarrow && {flexWrap: 'wrap', gap: Typography.gap.gap12}),
    },
    profileContainer: {
      flexDirection: 'row',
      gap: Typography.gap.gap20,
      alignItems: Typography.textAlign.centerAlign,
    },
    avatar: {
      width: Typography.width.width40,
      height: Typography.height.height40,
      borderRadius: Typography.radius.fullRound, // Half of width/height for a circle
      backgroundColor: theme.profileBGColor,
      justifyContent: Typography.textAlign.centerAlign,
      alignItems: Typography.textAlign.centerAlign,
    },
    initials: {
      color: theme.profileTextColor,
      fontSize: Typography.fontSize.fontSize12,
      fontWeight: Typography.fontWeight.semiBold,
      fontFamily: Typography.fontFamily.inter,
    },
    lineContainer: {
      borderColor: theme.menuLayoutDivider,
      borderWidth: Typography.borderWidth.borderWidth1,
      height: Typography.height.height32,
    },
    darkModeIcon: {
      fontSize: Typography.fontSize.fontSize20,
      lineHeight: Typography.fontSize.fontSize20,
    },
  });
